"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _propTypes = require("prop-types");

var _Headings = require("../Headings");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TitleContainer = _styledComponents.default.div`
	display: flex;
	justify-content: space-between;
	padding: 0px 25px;
	border-bottom: 1px solid ${_constants.colours.inputBorder};
	margin-bottom: 20px;

	@media (min-width: ${_constants.breakpoints.smallDesktop}) {
		padding: 20px 25px;
	}
`;

const DrawerTitle = ({
  title,
  closeButtonAction
}) => /*#__PURE__*/_react.default.createElement(TitleContainer, null, /*#__PURE__*/_react.default.createElement(_Headings.H2, null, title), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
  size: "medium",
  color: "primary",
  onClick: closeButtonAction,
  "aria-label": "Close drawer menu"
}, /*#__PURE__*/_react.default.createElement(_Clear.default, null)));

DrawerTitle.propTypes = {
  title: _propTypes.string.isRequired,
  closeButtonAction: _propTypes.func.isRequired
};
var _default = DrawerTitle;
exports.default = _default;